import { createContext } from 'react';
import { User, GoogleAuthProvider, FacebookAuthProvider, OAuthProvider } from 'firebase/auth';
import { AxiosInstance } from 'axios';
import { HttpMethods } from 'api/httpMethods';

export interface FirebaseAuthContextType {
  http: HttpMethods | null;
  axiosInstance: AxiosInstance | null;
  user: User | null;
  loading: boolean;
  isLogin: boolean;
  socialLoginWith: (provider: typeof GoogleAuthProvider | typeof FacebookAuthProvider | typeof OAuthProvider) => void;
  logout: (redirect?: boolean, provider?: string) => Promise<void>;
  checkLogin: (
    callbackFunction: Function,
    loginAlertModalOption?: {
      onClose?: () => void;
      closeOnBackdropClick?: boolean;
      callbackUrl?: string;
    },
    isStackModal?: boolean
  ) => void;
  auth?: any;
}

export const FirebaseAuthContext = createContext<FirebaseAuthContextType>({
  user: null,
  http: null,
  axiosInstance: null,
  loading: true,
  isLogin: false,
  socialLoginWith: () => {},
  logout: async () => {},
  checkLogin: () => {},
  auth: null,
});
